export const InvoiceSeparator: React.FC = () => {
  return (
    <div
      style={{
        width: "100%",
        height: 2,
        backgroundColor: "#696969",
        marginTop: 8,
        marginBottom: 8,
      }}
    />
  );
};
